import PropTypes from "prop-types"


const properties = {
  authenticationJwt: PropTypes.string,
  email: PropTypes.string.isRequired,
  id: PropTypes.string,
  is2FaEnabled: PropTypes.bool,
  mfaMethods: PropTypes.arrayOf(PropTypes.string),
  preferredMfaMethod: PropTypes.string
}

const AuthenticateAsOutputShapeShape = PropTypes.exact(properties)

export default AuthenticateAsOutputShapeShape
export { properties }
